import { useMemo } from 'react';
import { useQuery, QueryResult } from '@apollo/client';
// Api
import { PPV_TIERS } from 'api/streams/queries';
// Types
import { PpvTiers, PpvTiers_ppvTiers } from 'api/streams/types/PpvTiers';

export type PpvTier = PpvTiers_ppvTiers;

type UseGetPpvTiersResult = {
  tiers: PpvTier[];
  loading: boolean;
  error: boolean;
  refetch: QueryResult<PpvTiers>['refetch'];
};

export const useGetPpvTiers = (): UseGetPpvTiersResult => {
  const { data, loading, error, refetch } = useQuery<PpvTiers>(PPV_TIERS, {
    fetchPolicy: 'cache-and-network',
  });

  const tiers = useMemo(
    () => [...(data?.ppvTiers ?? [])].sort((a, b) => a.price - b.price),
    [data]
  );

  return { tiers, loading, error: Boolean(error), refetch };
};
